import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CAMolyData, CAMolyInForm, CAMolyValue} from '../../services/ca';
import {InterfaceService} from '../../services/interface.service';
import {AngularFireDatabase} from '@angular/fire/database';
import {RoehttpService} from '../../services/roehttp.service';

@Component({
  selector: 'app-ca-username',
  templateUrl: './ca-username.component.html',
  styleUrls: ['./ca-username.component.scss']
})
export class CaUsernameComponent implements OnInit {
  @Input()
  path: string;

  @Input()
  formusesukey: string;

  @Input()
  moly: CAMolyInForm;

  @Input()
  primarycolor = '#0000FF';

  @Input()
  secondarycolor = '#ffffff';

  @Input()
  indivukey: string;

  @Output()
  save = new EventEmitter<string>();

  firsttime = true;
  editdesc = false;
  olddescription: string;
  description: string;
  descdata: CAMolyData;

  scope = 'global';
  curlang = 'en';
  ukey: string;
  err2: string;

  constructor(private is: InterfaceService,
              private http: RoehttpService,
              private db: AngularFireDatabase) {
  }

  ngOnInit() {
    console.log(this.path, 'indivukeyasdf', this.indivukey)
    this.is.getObject(`${this.path}/formuses/${this.formusesukey}/${this.moly.moly.ukey}`)
      .take(1)
      .subscribe(val => {
        if (!val) {
          this.setUp();
        } else {
          this.ukey = val.ukey;
          let pth;
          if (val.scope === 'global') {
            pth = `${this.path}/data/${this.ukey}`;
          } else if (val.scope === 'local') {
            pth = `${this.path}/formvals/${this.formusesukey}/${this.ukey}`;
          }
          this.scope = val.scope;
          this.is.getObject(pth)
            .take(1)
            .subscribe(res => {
              this.firsttime = false;
              this.descdata = new CAMolyData();
              this.descdata.name = this.moly.moly.name;
              this.descdata.molyukey = this.moly.moly.ukey;
              this.descdata.value = res.value;
              this.description = this.descdata.value[this.descdata.value.length - 1].data;
              this.olddescription = this.description;
              this.editdesc = false;
            });
        }
      });
  }

  setUp() {
    this.ukey = this.db.createPushId();

    this.descdata = new CAMolyData();
    this.descdata.name = this.moly.moly.name;
    this.descdata.molyukey = this.moly.moly.ukey;
    this.descdata.value = [];
    this.description = '';
    this.olddescription = this.description;
    this.editdesc = true;
  }

  onInbox(str) {
    this.scope = str;
    this.firsttime = true;
  }

  onClickDesc() {
    this.editdesc = true;
  }

  onKeyUp(event) {
    // todo: check if Done is triggered
    if ((event.code === 'Enter' || event.key === 'Enter' || event.code === 'Done' || event.key === 'Done') &&
      (this.description.length > 3)) {
      this.editdesc = false;
      this.descriptionSave();
    }
  }

  descriptionSave() {
    console.log('desc save', this.description, this.olddescription)
    if (this.olddescription !== this.description) {

      if (!this.descdata.value) {
        this.descdata.value = [];
      }

      // there should be 3 parameters
      // 0 = new username
      // 1 = indivukey
      // 2 = old username - if the new username is good then delete the old username
      const identifier = `${this.description}+${this.indivukey}+${this.olddescription}`;
      this.http.getMMUsernameValid(this.description, this.indivukey, this.olddescription).then(res => {
        res.subscribe(val => {
          if (val.val === 'good' || val.val === 'already') {
            const v = new CAMolyValue();
            v.data = this.description;

            // todo: change to international time? save the timezone?
            v.date = new Date().getTime();
            this.descdata.value.push(v);
            this.olddescription = this.description;
            this.editdesc = false;

            let loc;
            if (this.scope === 'global') {
              loc = 'data';
            } else {
              loc = `formvals/${this.formusesukey}`;
            }
            this.is.setObjNoLog(`${this.path}/formuses/${this.formusesukey}/${this.moly.moly.ukey}`, {ukey: this.ukey, scope: this.scope});

            const p = `${this.path}/${loc}/${this.ukey}`;
            if (this.firsttime) {
              this.is.setObjNoLog(p, this.descdata);
              this.firsttime = false;
            } else {
              this.is.setObjNoLog(`${p}/value/${this.descdata.value.length - 1}`,
                this.descdata.value[this.descdata.value.length - 1]);
            }

            // emit success
            // todo: not sure if have to emit the ukey
            this.save.emit(this.ukey);

          } else {
            this.err2 = 'Not a valid username';
            return;
          }
        });
      });


    }
  }
}
